import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Video from 'video.js'
import 'video.js/dist/video-js.css'
import EmojiPickerPlugin from "vue-emoji-picker";
import uploader from 'vue-simple-uploader'
import "babel-polyfill";
Vue.use(uploader)

Vue.use(EmojiPickerPlugin)

Vue.prototype.$video = Video
router.beforeEach((to,from,next)=>{
  if(to.meta.title){
   document.title = "教师空间 - " + to.meta.title
  }
  next()
 })
Vue.use(ElementUI, {
  size: 'small'
});
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: function (h) {
    return h(App)
  }
}).$mount('#app')

import axios from 'axios'
axios.defaults.withCredentials = true;  //允许axios请求携带cookie等凭证